import { render, staticRenderFns } from "./_template-subtitle.vue?vue&type=template&id=ef755c06&scoped=true&"
import script from "./_template-subtitle.vue?vue&type=script&lang=js&"
export * from "./_template-subtitle.vue?vue&type=script&lang=js&"
import style0 from "./_template-subtitle.vue?vue&type=style&index=0&id=ef755c06&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef755c06",
  null
  
)

export default component.exports